import withFeatureBranch from '@wix/da-react-context/pkg/flags/withFeatureBranch';
import BackroomSection from './BackroomSection';
import BackroomSectionContainer from './BackroomSection.container';
import { default as BackroomSectionBranched } from './BackroomSection.deviation_gruser';

export default withFeatureBranch({
  gruser_backroom: BackroomSectionContainer(BackroomSectionBranched),
})(BackroomSectionContainer(BackroomSection));
